module.exports = __webpack_public_path__ + "static/media/Spanish-Subject-Personal-Pronouns.41fc715f.jpeg";